import React, { useEffect, useRef } from 'react';
import {CaptionListProps} from "../../../types/caption";
import CaptionInfo from "./CaptionInfo";
import CaptionData from "./CaptionData";
import CaptionButton from "./CaptionButton";
import styled from "styled-components";
import {useAtom} from "jotai";
import {captionItemState} from "../../../states/caption";
import CaptionETC from "./CaptionETC";
import OriginCaptionData from "./CaptionOriginData";
import { captionSelectionModeState, currentActivatedSegmentAtom } from '../../../states/initialize';

type CaptionItemProps = {
  captionData : CaptionListProps
  AICaptionData : CaptionListProps | null
}

/**
 자막 전체 레이아

 * @param data1 설명
 * @return {data1} 반환
 * @throws ValidException 예외 발생
 * @author plaq99@rumpus.co.kr
 * @date 03-20-2023
 */
export default function CaptionItem({captionData, AICaptionData}: CaptionItemProps) {

    const [currentActivatedSegment] = useAtom(currentActivatedSegmentAtom)
    const [isAutoCaptionHighlight] = useAtom(captionSelectionModeState)
    const [{currentCaptionId, captionSelectedId, captionSelectedOn}] = useAtom(captionItemState);

    const isMouseDownRef = useRef(false)
    const initialMouseXPos = useRef<number | null>(null)
    const initialWidth1 = useRef<number | null>(null)
    const initialWidth2 = useRef<number | null>(null)

    const activeOrNot = isAutoCaptionHighlight && captionData.seq == currentCaptionId
                        ? " active"
                        : !isAutoCaptionHighlight && currentActivatedSegment?.seq === captionData.seq
                        ? " active"
                        : "";

    const selectedOrNot =   captionSelectedOn && (captionData.seq == captionSelectedId)
                        // const selectedOrNot = isAutoCaptionHighlight && captionSelectedOn && (captionData.seq == captionSelectedId)
                          ? " selected"
                          : !isAutoCaptionHighlight && currentActivatedSegment?.seq === captionData.seq
                          ? " selected"
                          : ""

    const captionActiveOrNot = isAutoCaptionHighlight && captionData.seq == currentCaptionId
                              ? "captionActive"
                              : !isAutoCaptionHighlight && currentActivatedSegment?.seq === captionData.seq
                              ? "captionActive"
                              : ""

    useEffect(() => {

      window.addEventListener('mousemove', (e) => {

        if(!(isMouseDownRef.current && initialMouseXPos.current)) {return }
        const currentXPos = e.screenX

        let cachedResizeWidth : null | number = null
        Array.from(document.querySelectorAll('.can_resizable2')).map((willBeChangedElement, i) => {
          cachedResizeWidth = cachedResizeWidth ? cachedResizeWidth : ((initialWidth2.current!) + ((initialMouseXPos!.current! - currentXPos) / 2)) + 2;
          (willBeChangedElement as HTMLTextAreaElement).style.width = `${cachedResizeWidth}px`
        })
      })

      window.addEventListener('mouseup', () => {
        isMouseDownRef.current = false
      })
    }, []);

    const setResizeOn : React.MouseEventHandler<HTMLDivElement>  = e => {
      initialMouseXPos.current = e.screenX
      initialWidth1.current = document.querySelector('.can_resizable1')!.clientWidth
      initialWidth2.current = document.querySelector('.can_resizable2')!.clientWidth
      isMouseDownRef.current = true
    }

    return (
      <ListCaption
        className={`item ${activeOrNot} ${selectedOrNot}`}
        id={captionActiveOrNot}
      >
        <CaptionInfo captionData={captionData} />
        <CaptionInfoBox>
            <OriginCaptionData captionData={AICaptionData}/>
            <SplitArea
                onMouseDown={setResizeOn}
            />
            <CaptionData captionData={captionData} />
        </CaptionInfoBox>
        <CaptionButton captionData={captionData}/>
        <CaptionETC captionData={captionData}/>
      </ListCaption>
    );
}

const ListCaption = styled.li`
{
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  position: relative;
  padding: 10px;
  background-color: #222;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;

  + .item {
    border-top: 1px solid rgba(0, 0, 0, 0.3);
  }

  &:hover {
    background-color: #2f2f2f;

    .caption_btn_area {
      visibility: visible;
    }
  }


  &.selected {

    &:before {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      border: 3px solid #FF9800;
      content: "";
    }

  }

  &.active {
    background-color: #2f2f2f;

    &:before {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      border: 3px solid #0a87ff;
      content: "";
    }

    .input_text {
      border: 1px solid #1f1f1f;
      /*background-color: #1f1f1f;*/

      
    }
  }
  
}
`;

const SplitArea = styled.div`
  background-color: rgba(75, 241, 255, 0.89);
  width: 3px;
  cursor: ew-resize;
  z-index:1000;
`;

const CaptionInfoBox = styled.div`
  display : flex; 
  width : 100%
`;
